import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { SalesApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null
};

const SalesSlice = createSlice({
  name: 'sales',
  initialState,
  reducers: {
    setSalesGrid(state, action) {
      state.list_data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Sales List
export const getSalesList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: SalesApi?.salesList,
      method: 'post',
      payload: data
    });

    // console.log('sss salesList', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setSalesGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setSalesGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Sales List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Sales List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};
export const getMatchedDownloadList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: SalesApi?.salesMatchDownload,
      method: 'post',
      payload: data
    });

    console.log('sss match slice', res);
    return res;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setSalesGrid } = SalesSlice.actions;
export default SalesSlice.reducer;
